import React, { FC } from "react";
import { COLOR_GREY_6 } from "../colors";
import { IconType } from "./types";

export const RecentlyIcon: FC<IconType> = ({ color = COLOR_GREY_6 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM16 16C15.6095 16.3905 14.9765 16.3905 14.586 16L11.8787 13.2927C11.3161 12.7301 11 11.967 11 11.1714V7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7V11.586L16 14.586C16.3905 14.9765 16.3905 15.6095 16 16Z"
      fill={color}
    />
  </svg>
);
